import { CircleAlert } from 'lucide-react'

interface AuthErrorComponentProps {
  message: string
}

export function AuthErrorComponent({ message }: AuthErrorComponentProps) {
  return (
    <div className="flex flex-row flex-wrap items-center justify-center rounded-md border border-red-600 bg-red-50 p-3">
      <CircleAlert className="mr-2 h-4 w-4 text-red-600" />
      <p className="text-sm font-medium text-red-600">{message}</p>
    </div>
  )
}
